<div id="toolbar-sopra" *ngIf="subscription" [ngClass]="{'toggle': toggle }">
     <div class="nero">
        <div class="menu-scomparsa" (click)="clickToggle()"><i class="material-icons">&#xE5D2;</i></div><div class="welcome"><small>     {{ 'Benvenuto' | translate }} {{profilo}}</small>
            <ng-container *ngIf="utente && utente.lingue && utente.lingue.length>0">
                <div class="lingue"><img title="{{m.iso}}" *ngFor="let m of utente.lingue" src="{{imgPath}}{{m.bandiera}}" (click)="scegliLingua(m)"/></div>
        </ng-container>
            <a class="logout" (click)="logout()"><i class="material-icons">&#xE879;</i></a></div>
    </div>
    <div class="toolbar" >
        <a routerLink="/home"><img src="assets/logo_{{sezione}}.png" width="auto" height="40"/></a>
        <ul>
            <li *ngFor="let m of menu"><a (click)="clickMenu(m)" routerLink="{{m.path}}" routerLinkActive="active"> {{ m.nome| translate }}</a></li>
            <li *ngIf="utente && utente.carrello"><a (click)="clickMenu(m)" class="menucarrello"  routerLink="/carrello" routerLinkActive="active"><i class="material-icons">shopping_cart</i></a></li>
        </ul>

    </div>
</div><div class="chisuo" style="clear: both;"></div>


// WEBPACK FOOTER //
// ./src/app/tws-toolbar/tws-toolbar.component.html